(function () {
  'use strict';

  angular.module('eclipseApp.components').controller('searchCtrl', ['$scope', '$modalInstance', '$state', '$window', function ($scope, $modalInstance, $state, $window) {
    
    $scope.ok = function () {
      accountDashboardManager.resetConfirmation();
      $state.go('changeInternetPkg');
      $modalInstance.close();
    };

    $scope.cancel = function () {
      $modalInstance.dismiss('cancel');
    };
    
    $scope.submitSearch = function(search){  
      //'http://www.fido.ca/web/Fido.portal?_nfpb=true&_pageLabel=fido_search&Ntt='
    };
    
  }]);
})();
